import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { DEVICE_BREAKPOINT, HEADER_LARGE, LABEL_XS } from 'Shared/styles/designConstants';
import styled from 'styled-components';

export const ExploreContainer = styled.div`
  max-width: 412px;
  margin   : 0 auto;
`;

export const Title = styled.h1`
  ${HEADER_LARGE.DEFAULT}
  margin    : 40px 0 0 auto;
  color     : ${DESIGN_TOKENS.color.text.normal.value};
  max-width : 412px;
  text-align: center;

  span {
    ${HEADER_LARGE.BOLD}
  }

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    margin-top   : 24px;
  }
`;

export const DisclaimerContainer = styled.div`
  ${LABEL_XS.DEFAULT}
  color     : ${DESIGN_TOKENS.color.text.secondary.value};
  text-align: center;
  margin-top: 8px;
`;

export const StepperContainer = styled.div`
  max-width    : 372px;
  min-height   : 300px;
  height       : auto;
  margin-left  : 10px;
  margin-top   : 40px;
  margin-bottom: 10px;
`;

export const PolicyLink = styled.a`
  color: ${DESIGN_TOKENS.color.text.secondary.value};
`;